import { render, staticRenderFns } from "./CreateBasic.vue?vue&type=template&id=677ca61b&v-on-clickaway=cancel&"
import script from "./CreateBasic.vue?vue&type=script&lang=ts&"
export * from "./CreateBasic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports